<template>
  <md-subheader class="subheader" :class="[getNFClass]">
    <div class="subheader-content" :class="[{ 'no-goback-mt': !backButton }]" v-if="checkPageName">
      <h4 class="page-header-name mb-0" :class="[getPosition]">
        <md-button
          class="md-icon-button back-button"
          @click="$router.go(-1)"
          v-if="backButton"
        >
          <md-icon>arrow_back</md-icon>
        </md-button>
        {{ pageName }}
      </h4>
    </div>
    <div
      class="list-category scroll"
      :class="[isLandindPage]"
      v-if="
        (pageName === 'Feed' || pageName === 'Search' || !pageName || pageName === 'Landing Page')"
    >
      <slot name="categories"></slot>
    </div>
  </md-subheader>
</template>

<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
export default {
  name: "SSubHeader",
  props: ["pageName", "backButton"],
  mixins: [UserHelperVue],
  computed: {
    getNFClass() {
      if (
        (this.$route.path === "/s-app/feed" ||
          this.$route.name === "SSearchResultQuery" ||
          this.$route.name === "SSearchResult" ||
          this.$route.name === "SSearchResultFromLandingPage") &&
        !this.pageBottom
      ) {
        return "nf-subheader";
      }
      return "";
    },
    isLandindPage() {
      if (this.$route.name === "landingPage") {
        return "landing-page-subheader"
      }
      return "";
    },
    getPosition() {
      if (this.backButton) return "position-back-button";
      return "none-back-button";
    },
    checkPageName() {
      return this.pageName !== "Landing Page"
    },
  },
  data() {
    return {
      subHeaderPath: this.$route.fullPath
    }
  },
  methods: {
  }
};
</script>

<style scoped>
.md-subheader {
  top: 64px;
  position: absolute;
  width: 100%;
  z-index: 11;
  align-items: unset;
  flex-flow: unset;
}
.landing-page-subheader {
  top: 0 !important;
}
.subheader-content {
  background-color: #05919B;
  height: 40px;
  width: 100%;
  display: flex;
  padding-left: 64px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  position: fixed;
  z-index: 11;
  top: 63px;
}
.page-header-name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  letter-spacing: 1.25px;
  font-weight: bold;
  font-size: 22px;
  line-height: 16px;
  color: #fff;
}

.looking-categories {
  color: #fff;
  font-weight: normal;
  margin-top: 1rem;
  padding: 0 50px;
}

.list-category {
  margin-top: 50px;
  overflow: auto;
  white-space: nowrap;
}
.list-category ul {
  display: inline-block;
}

@media screen and (max-width: 600px) {
  .subheader,
  .page-header-name {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .md-subheader {
    top: 60px;
  }
}
@media screen and (max-width: 735px) {
  .page-header-name {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}
@media screen and (max-width: 720px) {
  .subheader-content {
    padding-left: 16px;
  }
  .position-back-button {
    margin-left: -14px;
  }
}
@media screen and (min-width: 961px) {
  .position-back-button {
    margin-left: -14px;
  }
}

@media screen and (min-width: 601px) and (max-width: 960px) {
  .md-subheader {
    top: 65px;
  }
  .subheader,
  .page-header-name {
    height: auto;
    display: flex;
    align-items: center;
    text-align: center;
  }
}
@media screen and (min-width: 961px) and (max-width: 1024px) {
  .md-subheader {
    top: 66px;
  }
}
@media screen and (max-width: 1024px) {
  .looking-categories,

  .subheader {
    height: auto;
  }
  .list-category {
    max-width: 90%;
    margin: auto;
    top: 45px;
    position: relative;
  }
  ::-webkit-scrollbar-thumb {
    background: #757575;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    background: #e1e1e1;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
  ::-webkit-scrollbar:vertical{
    display: none;
  }
  ::-webkit-scrollbar:horizontal{
    display: none;
  }
  ::-webkit-scrollbar {
    height: 10px;
  }
  .scroll {
    display: block;
    width: 100%;
    overflow: scroll;
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>
.subheader {
  flex-direction: column;
  padding: 0;
}
</style>

<style>
.looking-categories p {
  margin: 0;
}

.back-button i {
  color: white !important;
}
</style>

